<template>
  <div>
    <div v-if="!personalInfo?.personalInformation">
      <SystemAlert />
    </div>
    <div>
      <Tab />
    </div>
  </div>
</template>
  
<script setup>
import { useStore } from 'vuex';
import { computed, onMounted, onUnmounted } from 'vue';
import appConfig from '@/app.config';
import Tab from '../../components/tabs/Tab.vue';
import * as COMMONS from '../../store/_commons';
import SystemAlert from '@/components/SystemAlert';
import { useHead } from '@unhead/vue'

useHead({
  title: `Profile | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'You can view your Personal Information, Credentials, Registrations, Adjudications, Make Reservations'
    }
  ]
});

const store = useStore();

// Computed props
const personalInfo = computed(() => store.getters[COMMONS.GUEST_PERSONAL_INFO]);

// Functions 
const getProfile = () => {
  store.dispatch(COMMONS.GUEST_PROFILE);
};

getProfile();

// Ensure store flag is set correctly for individual users
store.commit('guestLogin/setState', { 
  property: 'isBusinessUser', 
  value: false 
});

store.state.guestLogin.loginUserDetails = null;

const handlePopstate = () => {
  history.go(1);
};

onMounted(() => {
  window.history.replaceState(history.state, "", window.location.href);

  window.addEventListener('popstate', handlePopstate);

  window.addEventListener("message", (event) => {
    if (event.origin !== "https://ridmvwebtest-dev.ri.gov") {
      return;
    }

    // Process the message data
    const message = event.data;
    console.log('Received message:', message);
  });
});

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopstate);
});
</script>
